import { motion } from 'framer-motion'
import styled from 'styled-components'

const RemountOnResize = styled(motion.div)``
export default RemountOnResize
